import React from 'react'
import { Modal } from 'components/Utility/Modal/Modal'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import styles from './StatusModal.module.scss'

type StatusModalProps = {
  isOpen: boolean,
  status: 'success' | 'error',
  modalText: React.ReactNode,
  buttonText: React.ReactNode,
  onClose?: () => void,
  onButtonClick?: () => void,
}

/** A success or error message with one button */
export const StatusModal: React.FC<StatusModalProps> = React.memo((props) => {
  const { isOpen, status, modalText, buttonText, onClose, onButtonClick } = props
  return (
    <Modal className={styles.container} isOpen={isOpen} onClose={onClose}>
      <div className={styles.content} data-status={status}>
        <div className={styles.icon} />
        <div className={styles.text}>{modalText}</div>
        <AppButton onClick={onButtonClick}>{buttonText}</AppButton>
      </div>
    </Modal>
  )
})
StatusModal.displayName = 'StatusModal'
